import { EventType } from '@/shared/enums';

export default {
  data() {
    return {
      loading: true,
    };
  },
  created() {
    this.$EventBus.on(EventType.PAGE_VIEW, this.pageView);
  },
  beforeDestroy() {
    this.$EventBus.off(EventType.PAGE_VIEW, this.pageView);
  },
  methods: {
    pageView() {
      this.loading = false;
      this.$deferredLoader.appReady.resolve();
    },
  },
};
